import { type FC } from 'react'

import { type RatingOwnerState } from 'base-ui'

type ProductHeadRatingAndQuestionsItemContainerProps = {
  ownerState: RatingOwnerState
  value: number
}

export const ProductHeadRatingAndQuestionsItemContainer: FC<
  ProductHeadRatingAndQuestionsItemContainerProps
> = ({ ownerState, value, ...rest }) => (
  <span
    data-qa-id={value <= ownerState.value ? 'active-rating-star' : undefined}
    {...rest}
  />
)
